import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog'
import {UCInfo} from '@sparbanken-syd/loan-backend'
import {UcInfoComponent} from '../7-uc-info/uc-info.component'

@Component({
  selector: 'spb-kalp-uc-result',
  templateUrl: './kalp-uc-result.component.html',
  imports: [
    UcInfoComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatDialogContent
  ]
})
export class KalpUcResultComponent {
  public data = inject<UCInfo | undefined>(MAT_DIALOG_DATA)
}
